var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn " + _vm.btnClass + " " + _vm.btnSize + " " + _vm.otherClass),attrs:{"disabled":_vm.disable,"type":"button"},on:{"click":_vm.buttonEvent}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }